import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = { class: "step-row__subtitle" }
const _hoisted_3 = { class: "step-row--block" }
const _hoisted_4 = { class: "step-row__subtitle" }
const _hoisted_5 = { class: "step-row__subtitle" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "step-row__subtitle" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "step-row__subtitle" }
const _hoisted_10 = { class: "step-row--block" }
const _hoisted_11 = { class: "step-row__subtitle" }
const _hoisted_12 = { class: "step-row__subtitle" }
const _hoisted_13 = { class: "step__title" }
const _hoisted_14 = { class: "step__subtitle" }
const _hoisted_15 = { class: "step__subtitle" }
const _hoisted_16 = { class: "step-row__description" }
const _hoisted_17 = {
  key: 0,
  class: "redirect"
}

import StrategyBriefHubStepLayout from '@/brief-hub/common/ui/layout/StrategyBriefHubStepLayout.vue';
    import PhoneNumberCompletionDialog from '@/common/components/PhoneNumberCompletionDialog.vue';
    import {computed, ref, watch} from 'vue';
    import {storeToRefs} from 'pinia';
    import {getPageLocale} from '@malt/dom';
    import {useGlobalProperties} from '@malt/vue3-use';
    import {useBriefConditions} from '@/brief-hub/brief/useBriefConditions';
    import {useConnectedUserStore} from '../../../stores/connectedUser.store';
    import {ClientIdentity, PhoneValidationStatus} from '@/common/api/api-raw-types';
    import {useTranslation} from '@malt/vue3-use';
    import {useBriefStrategyStore} from '@/brief-hub/stores/briefStrategy.store';
    import {RouteNames} from '@/brief-hub/router/route-names';
    import {useRouter} from 'vue-router';
    import userService from '@/brief-hub/user/UserService';
    import {useMediaQuery} from '@malt/joy-entrypoint/src/vue/use';
    import {pushVJoySnackbar} from '@maltjoy/core-vue';
    import {useBriefAmplitudeEvent} from '@/common/composable/useBriefAmplitudeEvent';
    import {context} from 'vue3-starter/src/typescript/app-context/AppContext';

    interface Company {
        id: string;
        name: string;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'StrategyBriefOverview',
  setup(__props) {

    const {msg} = useTranslation();
    const {$features} = useGlobalProperties();
    const router = useRouter();
    const {matchMedia} = useMediaQuery();

    const isPhoneNumberCompletionDialogOpen = ref<boolean>(false);

    const connectedUserStore = useConnectedUserStore();
    const {user} = storeToRefs(connectedUserStore);
    const selectedCompanyId = ref<string | undefined>('');
    const companies = ref<Company[]>([]);

    const briefStrategyStore = useBriefStrategyStore();
    const {brief} = storeToRefs(briefStrategyStore);
    const {triggerBriefFunnelStepEnteredAmplitudeEvent} = useBriefAmplitudeEvent();

    const freelancerJobTitle = computed(() => brief.value?.profileDetails.freelancerJobTitle);
    const experienceLevel = computed(() => msg(`customer.brief.exec.form.overview.1.profile.level.${brief.value?.profileDetails.experienceLevel}`));
    const industryExpertises = ref<string>();
    const functionalScopes = ref<string>();
    const skills = computed(() => brief.value?.profileDetails.freelancerSkills);
    const languages = computed(() => brief.value?.profileDetails.languages);

    const {duration, city, dailyFreelancerRate, freelancerAvailability, remote, startDate, isDurationMoreThanOneMonth, budget} = useBriefConditions(
        brief.value!.briefDetails,
        getPageLocale(),
    );

    const briefTitle = computed(() => brief.value?.briefDetails.title);
    const briefDescription = computed(() => brief.value?.briefDetails.description);

    const submitting = ref(false);
    const anonymous = computed((): boolean => !user.value);
    const allowSubmit = computed((): boolean => !submitting.value && (!!selectedCompanyId.value || anonymous.value));
    const userHasMultipleIdentities = computed((): boolean => companies.value && companies.value.length > 1);
    const anotherCompany = computed((): boolean => identityOfCompanyId.value !== user.value?.identityId);

    const identityOfCompanyId = computed((): string => {
        if (user.value && user.value.clientIdentities) {
            return user.value.clientIdentities
                .filter((identity) => identity.companyId === selectedCompanyId.value)
                .map((identity) => identity.identityId)[0];
        }
        return '';
    });

    const computePaddingSize = computed(() => (matchMedia.value.max.Xs ? 'small' : 'medium'));

    const userMustUpgrade = computed((): boolean => !user.value || user.value?.serviceLevelType === 'STANDARD');

    async function getOntologiesTranslations() {
        const [data, error] = await brief.value!.strategyOntologiesTranslations();
        if (error || !data) {
            pushVJoySnackbar({props: {message: msg('customer.brief.error.unknown'), level: 'error'}});
        } else {
            industryExpertises.value = data.profileDetails.industryExpertises
                .map((scope) => scope.businessSectorTranslation + ' - ' + scope.businessIndustryTranslation)
                .toString();

            functionalScopes.value = data.profileDetails.functionalScopes
                .map((scope) => scope.globalScopeTranslation + ' - ' + scope.specificScopeTranslation)
                .toString();
        }
    }

    async function init() {
        await connectedUserStore.getConnectedUser();
        await getOntologiesTranslations();
        triggerBriefFunnelStepEnteredAmplitudeEvent('overview', 8);
    }

    function getCompanies(clientIdentities: ClientIdentity[]): Company[] {
        return clientIdentities.map((identity) => {
            return {
                id: identity.companyId,
                name: identity.companyName,
            };
        });
    }

    function backToEdit(routeName: string): void {
        router.push({
            name: routeName,
            params: {id: brief.value?.briefId},
        });
    }

    async function submitBrief(): Promise<void> {
        if ($features.projectProposalBriefNoMoreServiceLevelNeeded && !user.value) {
            submitting.value = true;
            window.location.href = `/customer/searches/draft/${brief.value?.briefId}/signup-submit`;
            return;
        }
        const [phoneStatus, e] = await context.httpService.get<PhoneValidationStatus>(context.registry.entries.getPhoneStatus());

        if (phoneStatus === PhoneValidationStatus.PHONE_NUMBER_MISSING) {
            isPhoneNumberCompletionDialogOpen.value = true;
            return;
        }

        if (e) {
            console.error(e);
            pushVJoySnackbar({props: {message: msg('customer.brief.error.unknown'), level: 'error'}});
            return;
        }

        submitting.value = true;

        if (anonymous.value && brief.value) {
            window.location.href = brief.value.links.signupSubmit();
            return Promise.resolve();
        }

        if (userMustUpgrade.value && brief.value) {
            window.location.href = brief.value.links.goToServiceLevel();
            return Promise.resolve();
        }

        const [, error] = await launchStrategyBrief({
            identityId: identityOfCompanyId.value,
        });
        submitting.value = false;

        if (error) {
            if (error.response && error.response.status === 401 && error.response.data && error.response.data.redirectUrl) {
                window.location.href = error.response.data.redirectUrl;
                return;
            }
            pushVJoySnackbar({props: {message: msg('customer.brief.error.unknown'), level: 'error'}});
        } else {
            if (anotherCompany.value) {
                // Client has selected another company for this brief. We need to log current user with this selected identity.
                // If we dont, we won't be able to see created brief because this brief is attached to this selected identity.
                await logUserWithSelectedIdentity();
            } else {
                pushVJoySnackbar({props: {message: msg('customer.brief.exec.form.submitted'), level: 'success'}});

                const briefId = brief.value!.briefId;
                window.location.href = `/client/sourcing-projects/${briefId}/search?entry_point=brief`;
            }
        }
    }

    async function launchStrategyBrief(payload: {identityId: string}) {
        briefStrategyStore.updatePayload({
            type: 'BriefSubmissionRequest',
            payload: {
                identityId: payload.identityId,
            },
        });
        return await briefStrategyStore.saveStrategyBrief();
    }

    function logUserWithSelectedIdentity(): void {
        // we want to make sure the button is disabled during the post of the identity selection form
        submitting.value = true;
        userService.redirectToIdentity(identityOfCompanyId.value, `/customer/searches/${brief.value?.briefId}/details`);
    }

    watch(
        user,
        () => {
            if (!user.value) {
                return;
            }
            if (user.value.clientIdentities) {
                companies.value = getCompanies(user.value.clientIdentities);
            }
            selectedCompanyId.value = user.value.companyId;
        },
        {immediate: true},
    );

    init();

return (_ctx: any,_cache: any) => {
  const _component_VJoyPanel = _resolveComponent("VJoyPanel")!
  const _component_VJoyLabel = _resolveComponent("VJoyLabel")!
  const _component_VJoySelect = _resolveComponent("VJoySelect")!
  const _component_VJoyButton = _resolveComponent("VJoyButton")!
  const _component_VJoyTag = _resolveComponent("VJoyTag")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(StrategyBriefHubStepLayout, { hasFooter: false }, {
      default: _withCtx(() => [
        _createVNode(_component_VJoyWrapper, {
          direction: "column",
          align: "stretch",
          class: "strategy-brief-overview__wrapper",
          "no-margin": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_VJoyPanel, {
              "no-margin": true,
              padding: computePaddingSize.value
            }, {
              "panel-title": _withCtx(() => [
                _createElementVNode("h2", null, _toDisplayString(_ctx.$msg('customer.brief.exec.form.overview.1.introduction.title')), 1)
              ]),
              "panel-body": _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(_unref(msg)('customer.brief.exec.form.overview.1.introduction.description')), 1)
              ]),
              _: 1
            }, 8, ["padding"]),
            (!anonymous.value)
              ? (_openBlock(), _createBlock(_component_VJoyPanel, {
                  key: 0,
                  "no-margin": "",
                  padding: computePaddingSize.value
                }, {
                  "panel-title": _withCtx(() => [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.$msg('customer.brief.exec.form.overview.2.company.title')), 1)
                  ]),
                  "panel-body": _withCtx(() => [
                    _createVNode(_component_VJoyLabel, null, {
                      default: _withCtx(() => [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$msg('customer.brief.exec.form.overview.2.company.label')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_VJoySelect, {
                      modelValue: selectedCompanyId.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCompanyId).value = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companies.value, (company) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: company.id,
                            value: company.id
                          }, _toDisplayString(company.name), 9, _hoisted_1))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["padding"]))
              : _createCommentVNode("", true),
            _createVNode(_component_VJoyPanel, {
              "no-margin": "",
              padding: computePaddingSize.value
            }, {
              "panel-title": _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$msg('customer.brief.exec.form.overview.3.profile.title')), 1)
              ]),
              "panel-body": _withCtx(() => [
                _createElementVNode("div", {
                  class: "step-row__back",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (backToEdit(_unref(RouteNames).STRATEGY_BRIEF_FREELANCER_PROFILE)))
                }, [
                  _createVNode(_component_VJoyButton, {
                    icon: "pen",
                    circle: "",
                    size: "small",
                    variant: "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$msg('general.edit')), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("strong", null, _toDisplayString(freelancerJobTitle.value), 1),
                    _createTextVNode(" - " + _toDisplayString(experienceLevel.value) + " - " + _toDisplayString(_unref(dailyFreelancerRate)) + _toDisplayString(_ctx.$msg('customer.brief.exec.form.freelancer.profile.daily.rate.unit', '')), 1)
                  ])
                ]),
                _createElementVNode("div", {
                  class: "step-row__back",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (backToEdit(_unref(RouteNames).STRATEGY_BRIEF_FREELANCER_FUNCTIONAL_SCOPES)))
                }, [
                  _createVNode(_component_VJoyButton, {
                    icon: "pen",
                    circle: "",
                    size: "small",
                    variant: "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$msg('general.edit')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_VJoyLabel, null, {
                    default: _withCtx(() => [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$msg('customer.brief.exec.form.overview.3.profile.2.functional.scope.label')), 1)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(functionalScopes.value), 1)
                ]),
                _createElementVNode("div", {
                  class: "step-row__back",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (backToEdit(_unref(RouteNames).STRATEGY_BRIEF_FREELANCER_INDUSTRY_EXPERTISES)))
                }, [
                  _createVNode(_component_VJoyButton, {
                    icon: "pen",
                    circle: "",
                    size: "small",
                    variant: "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$msg('general.edit')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_VJoyLabel, null, {
                    default: _withCtx(() => [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$msg('customer.brief.exec.form.overview.3.profile.1.industry.expertise.label')), 1)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(industryExpertises.value), 1)
                ]),
                _createElementVNode("div", {
                  class: "step-row__back",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (backToEdit(_unref(RouteNames).STRATEGY_BRIEF_FREELANCER_SKILLS)))
                }, [
                  _createVNode(_component_VJoyButton, {
                    icon: "pen",
                    circle: "",
                    size: "small",
                    variant: "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$msg('general.edit')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_VJoyLabel, null, {
                    default: _withCtx(() => [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$msg('customer.brief.exec.form.overview.3.profile.3.skills.label')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_VJoyWrapper, {
                    "row-gap": "2",
                    "column-gap": "2"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skills.value, (skill) => {
                        return (_openBlock(), _createBlock(_component_VJoyTag, {
                          key: skill,
                          label: skill
                        }, null, 8, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_VJoyLabel, null, {
                    default: _withCtx(() => [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$msg('customer.brief.exec.form.overview.3.profile.3.languages.label')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_VJoyWrapper, {
                    "row-gap": "2",
                    "column-gap": "2"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (language) => {
                        return (_openBlock(), _createBlock(_component_VJoyTag, {
                          key: language.code,
                          variant: "secondary",
                          label: language.label
                        }, null, 8, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["padding"]),
            _createVNode(_component_VJoyPanel, {
              "no-margin": "",
              padding: computePaddingSize.value
            }, {
              "panel-title": _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$msg('customer.brief.exec.form.overview.4.conditions.title')), 1)
              ]),
              "panel-body": _withCtx(() => [
                _createElementVNode("div", {
                  ref: "briefWhenConditions",
                  class: "step-row__back",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (backToEdit(_unref(RouteNames).STRATEGY_BRIEF_WHEN_CONDITIONS)))
                }, [
                  _createVNode(_component_VJoyButton, {
                    icon: "pen",
                    circle: "",
                    size: "small",
                    variant: "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$msg('general.edit')), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$msg('customer.brief.conditions.when.duration')), 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(duration)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$msg('customer.brief.conditions.when.start')), 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(startDate)), 1)
                    ]),
                    (_unref(isDurationMoreThanOneMonth)())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$msg('customer.brief.conditions.when.frequency')), 1),
                          _createElementVNode("div", null, _toDisplayString(_unref(freelancerAvailability)), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$msg('customer.brief.conditions.when.budget')), 1),
                          _createElementVNode("div", null, _toDisplayString(_unref(budget)), 1)
                        ]))
                  ])
                ], 512),
                _createElementVNode("div", {
                  ref: "briefWhereConditions",
                  class: "step-row__back",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (backToEdit(_unref(RouteNames).STRATEGY_BRIEF_WHERE_CONDITIONS)))
                }, [
                  _createVNode(_component_VJoyButton, {
                    icon: "pen",
                    circle: "",
                    size: "small",
                    variant: "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$msg('general.edit')), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$msg('customer.brief.conditions.where.remote')), 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(remote)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$msg('customer.brief.conditions.where.address')), 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(city)), 1)
                    ])
                  ])
                ], 512)
              ]),
              _: 1
            }, 8, ["padding"]),
            _createVNode(_component_VJoyPanel, { padding: computePaddingSize.value }, {
              "panel-title": _withCtx(() => [
                _createElementVNode("h2", _hoisted_13, _toDisplayString(_ctx.$msg('customer.brief.exec.form.overview.5.mission.title')), 1)
              ]),
              "panel-body": _withCtx(() => [
                _createElementVNode("div", {
                  ref: "briefMissionTitle",
                  class: "step-row__back",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (backToEdit(_unref(RouteNames).STRATEGY_BRIEF_MISSION_DESCRIPTION)))
                }, [
                  _createVNode(_component_VJoyButton, {
                    icon: "pen",
                    circle: "",
                    size: "small",
                    variant: "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$msg('general.edit')), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("p", _hoisted_14, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$msg('customer.brief.exec.form.overview.5.mission.subject')), 1)
                  ]),
                  _createElementVNode("p", null, _toDisplayString(briefTitle.value), 1)
                ], 512),
                _createElementVNode("div", {
                  ref: "briefMissionDescription",
                  class: "step-row__back",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (backToEdit(_unref(RouteNames).STRATEGY_BRIEF_MISSION_DESCRIPTION)))
                }, [
                  _createVNode(_component_VJoyButton, {
                    icon: "pen",
                    circle: "",
                    size: "small",
                    variant: "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$msg('general.edit')), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("p", _hoisted_15, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$msg('customer.brief.exec.form.overview.5.mission.description')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(briefDescription.value), 1)
                ], 512)
              ]),
              _: 1
            }, 8, ["padding"]),
            _createVNode(_component_VJoyPanel, {
              "no-margin": "",
              padding: computePaddingSize.value
            }, {
              "panel-body": _withCtx(() => [
                _createVNode(_component_VJoyWrapper, {
                  justify: "center",
                  "no-margin": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_VJoyButton, {
                      variant: "main",
                      disabled: !allowSubmit.value,
                      "data-testid": "Brief-overview-footer_submit-btn",
                      onClick: submitBrief
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(!_unref($features).projectProposalBriefNoMoreServiceLevelNeeded && userMustUpgrade.value
                                        ? _ctx.$msg('customer.brief.exec.form.overview.launch.project.cta.upgrade')
                                        : _ctx.$msg('customer.brief.exec.form.overview.launch.project.cta')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    (userHasMultipleIdentities.value && anotherCompany.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.$msg('customer.brief.exec.form.overview.company.redirection')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["padding"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(PhoneNumberCompletionDialog, {
      open: isPhoneNumberCompletionDialogOpen.value,
      onCancel: _cache[9] || (_cache[9] = ($event: any) => (isPhoneNumberCompletionDialogOpen.value = false)),
      onConfirm: submitBrief
    }, null, 8, ["open"])
  ]))
}
}

})